export default __webpack_public_path__ + "61e8c9397e7c7063c929a938c2f1da72.png";